const state = {
  commune: null,
  district: null,
  province: null,
  communes: [],
  districts: [],
  provinces: []
}

const getters = {}

const mutations = {
  setCommune (state, commune) {
    state.commune = commune
  },

  setDistrict (state, district) {
    state.district = district
  },

  setProvince (state, province) {
    state.province = province
  },

  setCommunesOption (state, communes) {
    state.communes = communes
  },

  setDistrictsOption (state, districts) {
    state.districts = districts
  },

  setProvincesOption (state, provinces) {
    state.provinces = provinces
  },

  resetAllSelectedLocation (state) {
    state.province = null
    state.district = null
    state.commune = null
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
